<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showAddReviews"
        class="bg-black fixed bg-opacity-70  inset-0 z-50 h-screen w-full"
      >
        <div
          class="fixed overflow-auto center-h-v m-5 bg-white rounded-md shadow-2xl sm:w-2/3  w-full"
        >
          <div class="flex justify-between items-center border-b-1.5 p-3">
            <p class="text-base font-bold">Goal Name One Review</p>
            <img
              v-if="!loading"
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close()"
            />
          </div>
          <div class="grid grid-cols-3 p-3 gap-3">
            <div class="text-sm">
              <label class="block pb-1">Goal Name</label><br />
              <input
                type="text"
                class="p-2 bg-gray-200 rounded-full w-full"
                placeholder="Goal Name Here"
              />
            </div>
            <div class="text-sm">
              <label class="block pb-1">Goal Measure</label><br />
              <input
                type="text"
                class="p-2 bg-gray-200 rounded-full w-full"
                placeholder="Goal Measure Here"
              />
            </div>
            <div class="text-sm">
              <label class="block pb-1">Goal Target</label><br />
              <input
                type="text"
                class="p-2 bg-gray-200 rounded-full w-full"
                placeholder="Goal Target Here"
              />
            </div>
            <div class="text-sm">
              <label class="block pb-1">Start Date</label><br>
              <input
                type="text"
                onfocus="(this.type='date')"
                onbur="(this.type='text')"
                placeholder="Start Date"
                class="rounded-xl w-full pl-4 py-3 bg-gray-200 text-sm"
              />
            </div>
            <div class="text-sm">
              <label class="block pb-1">End Date</label><br>
              <input
                type="text"
                onfocus="(this.type='date')"
                onbur="(this.type='text')"
                placeholder="End Date"
                class="rounded-xl w-full pl-4 py-3 bg-gray-200 text-sm"
              />
            </div>
          </div>
          <div class="grid grid-cols-12 p-4 gap-5 ">
              <div class="h4 font-bold">Description</div> 
              
          </div>
          <div class="text-sm px-4 pb-2">Lorem ipsum, dolor sit amet consectetur adipisicing elit. Doloribus aliquam, tempora doloremque ducimus dolores sapiente nam accusamus magni officia velit et atque magnam voluptatum obcaecati exercitationem voluptatibus. Adipisci, itaque tempora!</div>
          <div class="m-10 bg-gray-100 rounded-md">
            <div class="border-b-1.5 p-2">
              <p class="text-sm font-bold">My Reviews</p>
            </div>
            <div class="grid grid-cols-3 gap-5 p-4">
              <div class="text-sm">
                <label class="block pb-1">Target Objectives</label><br>
                <input
                  type="text"
                  class="p-2 py-3 bg-white rounded-full w-full"
                  placeholder="Results Measure Unit"
                />
              </div>
              <div class="text-sm">
                <label class="block pb-1">My Rating</label><br>
                <input
                  type="text"
                  class="p-2 py-3 bg-white rounded-full w-full"
                  placeholder="95%"
                />
              </div>
              
              <div class="text-sm">
                <label class="block pb-1">Attachments</label><br>
                <input
                  type="text"
                  class="p-2 py-3 bg-white rounded-full w-full"
                  placeholder="Result target Numbe"
                />
              </div>
             
            </div>
            <div class="grid grid-cols-12 p-4 gap-5 ">
              <div class="h4 font-bold">Description</div> 
              
          </div>
          <div class="text-sm px-4 pb-2 bg-white m-5 p-3 rounded ">Lorem ipsum, dolor sit amet consectetur adipisicing elit. Doloribus aliquam, tempora doloremque ducimus dolores sapiente nam accusamus magni officia velit et atque magnam voluptatum obcaecati exercitationem voluptatibus. Adipisci, itaque tempora!</div><br>
          </div>

          <div class="flex justify-end p-5">
            <button
              class="bg-primary rounded-full px-5 text-sm text-white py-3 "
            >
               Save 
            </button>
          </div>
        </div>
      </div>
      >
    </transition>
  </div>
</template>

<script>
export default {
  name: "AddReviews",
  props: ["showAddReviews"],
  data() {
    return {
      selectedType: "single",
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
